import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ls from "local-storage";
import styled from "styled-components";

import falk_ from "../../assets/images/falk_.png";
import icn_img from "../../assets/images/icn.svg";
import pdf_img from "../../assets/images/pdf.svg";
import { Button } from "../ui-kit/styled-templates";

import top_stats_im0 from "../../assets/images/top_stats_im0.png";
import bottom_stats_im0 from "../../assets/images/bottom_stats_im0.png";

import falk_square from "../../assets/images/falk_square.jpg";
import PartnersListTool from "../partners/tools/PartnersListTool";

import im_00_1 from "../../assets/images/im_00_1.png";
import im_00_2 from "../../assets/images/img_00_2.png";
import im_00_3 from "../../assets/images/im_00_3.png";

import rect_01_img from "../../assets/images/np_01.jpg";
import rect_02_img from "../../assets/images/prof_01.jpg";
import rect_03_img from "../../assets/images/kul_01.jpg";

const ContactsPage = () => {

    const [bigUrl, setBigUrl] = useState(undefined);
    const { t, i18n } = useTranslation();

    let isRu = i18n.language == "ru";
    let isEn = i18n.language == "en";

    return (
        <OuterWrapper className={"about_page"}>
            <Wrapper>

                <NewContent>

                    <TripletPlaceholder className={"about_triplet_placeholder"}>
                        <TripletItem style={{ flex: 2, paddingLeft: "0px" }}>
                            <Heading40>
                                {isRu ? 'Пресс-кит' : 'Press-kit'}
                            </Heading40>
                            <div style={{ fontFamily: "'Noto Sans', sans-serif" }}>
                                <div className={'mb-2'} >
                                    <MyA href={'https://disk.yandex.ru/i/BJEhhhnBRqolxQ'} style={{color: 'black'}} target={'_blank'} >
                                        {isRu ? 'Основная презентация' : 'Main presentation'}
                                    </MyA>
                                </div>

                                <div className={'mb-2'} >
                                    <MyA href={'https://disk.yandex.ru/d/qyu9Xx6Etd4uVw'} target={'_blank'}  >
                                        {isRu ? 'Баннеры' : 'Banners'}
                                    </MyA>
                                </div>

                                <div className={'mb-2'} >
                                    <MyA href={'https://disk.yandex.ru/d/yM5a8v68FhEvmQ'} target={'_blank'}  >
                                        {isRu ? 'Шрифты' : 'Fonts'}
                                    </MyA>
                                </div>

                                <div className={'mb-2'} >
                                    <MyA href={'https://disk.yandex.ru/d/K_oZ9lZCjEis4Q'} target={'_blank'}  >
                                        {isRu ? 'Брендбук' : 'Brand book'}
                                    </MyA>
                                </div>

                                <div className={'mb-2'} >
                                    <MyA href={'https://disk.yandex.ru/d/G9LfNQ86hQMCMQ'} target={'_blank'}  >
                                        {isRu ? 'Логотипы' : 'Logos'}
                                    </MyA>
                                </div>


                            </div>

                            {/*<Heading40 style={{marginTop: 50}} >*/}
                            {/*    {isRu ? 'Логотипы' : 'Logos'}*/}
                            {/*</Heading40>*/}
                            {/*<div style={{ fontFamily: "'Noto Sans', sans-serif" }}>*/}
                            {/*    <div className={'mb-2'} >*/}
                            {/*        <a href={'https://disk.yandex.ru/d/x4YZjmX58a_ccQ'} target={'_blank'} >*/}
                            {/*            {isRu ? 'Студтуризм' : 'Studtourism'}*/}
                            {/*        </a>*/}
                            {/*    </div>*/}
                            {/*    <div className={'mb-2'} >*/}
                            {/*        <a href={'https://disk.yandex.ru/d/1Jzp9jOuoBouZQ'} target={'_blank'} >*/}
                            {/*            {isRu ? ' Минобрнауки России' : 'Ministry of Education of Russia'}*/}
                            {/*        </a>*/}
                            {/*    </div>*/}
                            {/*    <div className={'mb-2'} >*/}
                            {/*        <a href={'https://drive.google.com/drive/folders/183QIb2ywTImuLxtwp_dxmCaHZ3CQAND4'} target={'_blank'} >*/}
                            {/*            {isRu ? 'Армат' : 'Armat'}*/}
                            {/*        </a>*/}
                            {/*    </div>*/}

                            {/*</div>*/}

                        </TripletItem>

                    </TripletPlaceholder>



                    <div style={{ display: "flex", flexDirection: "row" }} className={"bottom_docs_placeholder"}>

                        <RightBox style={{ flex: 1, marginRight: 20 }} className={"contacts_placeholder"}>
                            <RightHeading>{isRu ? 'Социальные сети' : 'Social networks'}</RightHeading>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between"
                                }}
                            >
                                {/*<div style={{ marginRight: 10 }}>*/}
                                {/*    <BLabel>{t("4zpid7rxkfk")}</BLabel>*/}
                                {/*    <div>8-800-707-71-61</div>*/}
                                {/*</div>*/}
                                <div>
                                    <BLabel>{isRu ? 'Телеграм' : 'Telegram'}</BLabel>
                                    <div style={{ marginBottom: 15 }}>
                                        <a href={"https://t.me/studturism"}
                                           style={{ fontFamily: "'Noto Sans', sans-serif", color: '#723DD3' }}>t.me/studturism</a>
                                    </div>
                                    <BLabel>{isRu ? 'Вконтакте' : 'VK.com'}</BLabel>
                                    <div style={{ marginBottom: 15 }}>
                                        <a href={"https://vk.com/studturism"}
                                           style={{ fontFamily: "'Noto Sans', sans-serif", color: '#723DD3' }}>vk.com/studturism</a>
                                    </div>
                                </div>
                            </div>
                        </RightBox>

                        <RightBox style={{ flex: 1, marginLeft: 20 }} className={"contacts_placeholder"}>
                            <RightHeading>{t("zkdxrldl3i")}</RightHeading>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between"
                                }}
                            >
                                {/*<div style={{ marginRight: 10 }}>*/}
                                {/*    <BLabel>{t("4zpid7rxkfk")}</BLabel>*/}
                                {/*    <div>8-800-707-71-61</div>*/}
                                {/*</div>*/}
                                <div>
                                    <BLabel>{t("y4jzg68214")}</BLabel>
                                    <div style={{ marginBottom: 15 }}>
                                        <a href={"mailto:info@mst22.ru"}
                                           style={{ fontFamily: "'Noto Sans', sans-serif", color: '#723DD3' }}>info@mst22.ru</a>
                                    </div>
                                    <BLabel>{t("sio6jb5adr")}</BLabel>
                                    <div style={{ marginBottom: 15 }}>
                                        <a href={"mailto:support@mst22.ru"}
                                           style={{ fontFamily: "'Noto Sans', sans-serif", color: '#723DD3' }}>support@mst22.ru</a>
                                    </div>


                                    <BLabel>{isRu ? 'Информационное сотрудничество' : 'PR'}</BLabel>
                                    <div>
                                        <a href={"mailto:pr@mst22.ru"}
                                           style={{ fontFamily: "'Noto Sans', sans-serif", color: '#723DD3' }}>pr@mst22.ru</a>
                                    </div>

                                </div>
                            </div>
                        </RightBox>


                    </div>


                </NewContent>

            </Wrapper>

            {bigUrl == undefined ? null : (
                <GlobalWarningPlaceholder>
                    <WhiteBox>
                        <img src={bigUrl} style={{ width: "100%" }} />

                        <WarningButtonPlaceholder>
                            <Button
                                onClick={() => {
                                    ls("first-visit-warning", false);
                                    setBigUrl(undefined);
                                }}
                            >
                                {t("k6a0kbmm5p")}
                            </Button>
                        </WarningButtonPlaceholder>
                    </WhiteBox>
                </GlobalWarningPlaceholder>
            )}
        </OuterWrapper>
    );
};

const MyA = styled.a`
    color: gray !important;
`;

const StH = styled.div`
  font-size: 24px;
  @media (max-width: 800px) {
    font-size: 20px;
  }
`;

const ProImg = styled.img`
  height: 160px;
  @media (max-width: 820px) {
    height: 100px;
  }
`;

const Heading50 = styled.div`
  font-size: 50px;
  line-height: 58px;
  @media (max-width: 1200px) {
    font-size: 34px;
    line-height: 40px;
  }
`;

const Heading40 = styled.div`
  font-size: 40px;
  line-height: 58px;
  margin-bottom: 15px;
  color: #723DD3;
  @media (max-width: 1200px) {
    font-size: 34px;
    line-height: 40px;
  }
`;

const ProDescription = styled.div`
  margin-top: 5px;
  @media (max-width: 800px) {
    font-size: 18px;
    margin-top: 0px;
  }
`;

const ProName = styled.div`
  font-size: 24px;
  line-height: 36px;
  padding-right: 20px;
  @media (max-width: 1200px) {
    font-size: 20px;
    line-height: 22px;
  }
`;

const Heading30 = styled.div`
  font-size: 24px;
  line-height: 36px;
  padding-right: 40px;
  @media (max-width: 1200px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

const TripletTypesPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 800px) {
    display: block;
  }
`;

const BotItem = styled.div`
  display: flex;
  flex-direction: row;
`;

const TripetTypeItem = styled.div`
  box-sizing: border-box;
  flex: 1;
  padding: 10px;
  position: relative;
  height: 300px;
  width: 33.33%;

  @media (max-width: 1200px) {
    display: block;
    width: 50%;
  }

  @media (max-width: 800px) {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
`;

const TripletImage = styled.img`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;

const TripletTextPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  left: 15px;
  bottom: 15px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 5px;
`;

const TripletText = styled.div`
  //color: black;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 32px;
`;

const RightItemsList = styled.div`

`;

const RightItem = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: "Noto Sans", sans-serif;
  text-align: left;
`;

const RightItemFirst = styled.div`
  width: 70px;
  min-width: 70px;
  //marginRight: 20px;
  font-family: "Noto Sans", sans-serif;
  fontSize: 72px;
  text-align: left;
  opacity: 0.5;
  @media (max-width: 800px) {
    width: 40px;
    min-width: 40px;
  }
`;

const RightItemSecond = styled.div`
  box-sizing: border-box;
  //padding-left: 20px;
  text-align: left;
  //padding-right: 20px;
  //width: 300px;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 800px) {
    font-size: 18px;
  }
  //font-weight: bold;
`;

const RightItemThird = styled.div`
  flex: 1;
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  line-height: 28px;
`;

const FirstInnerTd = styled.div`
  padding-right: 30px;
`;

const SecondInnerTd = styled.div`
  opacity: 0.5;
  font-style: italic;
  font-size: 20px;
`;

const TopQuote = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 50px;
`;

const TopRightQuote = styled.div`
  text-align: justify;
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  line-height: 40px;
  margin-left: 40px;
  margin-top: -70px;
  //margin-bottom: 50px;
  //width: 620px;
  flex: 1;
  font-style: italic;
  @media (max-width: 1200px) {
    margin-top: 0px;
  }
  @media (max-width: 800px) {
    font-size: 20px !important;
  }

`;

const LeftFalk = styled.div`
  //flex: 1;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  @media (max-width: 1200px) {
    //width: 100%;
    width: 300px;
    padding-right: 0px;
  }
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const FalkImg = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 1000px;
`;

const Falk = styled.div`
  //font-style: italic;
  font-size: 16px;
  padding: 20px;
  text-align: center;
  font-family: "Noto Sans", sans-serif;
`;

const TopImg = styled.img`
  display: block;
  width: 100%;
  @media (max-width: 820px) {
    display: none;
  }
`;

const GlobalWarningPlaceholder = styled.div`
  position: fixed;
  z-index: 100;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WhiteBox = styled.div`
  padding: 20px;
  border-radius: 8px;
  text-align: justify;
  background: white;
  width: 620px;
  box-sizing: border-box;
  @media (max-width: 620px) {
    width: calc(100vw - 40px);
    padding: 10px;
  }
`;

const WarningButtonPlaceholder = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoImg = styled.div`
  width: 240px;
  height: 240px;
  box-sizing: border-box;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.src});
  margin: 10px;
  cursor: pointer;
`;

const Ul = styled.ul`
  box-sizing: border-box;
  padding-left: 15px;
  margin-bottom: 25px;
`;

const Li = styled.li`
  margin-bottom: 10px;
  box-sizing: border-box;
`;

const Heading2 = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  color: #212121;
`;

const BLabel = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
  font-family: "Noto Sans", sans-serif;
`;

const DownImg = styled.img`
  height: 24px;
  cursor: pointer;
`;

const FileItemHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
  font-family: "Noto Sans", sans-serif;
`;

const FileItemSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #aaaaaa;
  font-family: "Noto Sans", sans-serif;
`;

const RightContentPlaceholder = styled.div``;

const MyP = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
  margin-bottom: 15px;
`;

const FileItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
`;

const FileItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const FileItemLeft = styled.div`
  flex: 1;
`;

const FileItemRight = styled.div``;

const FileImg = styled.img`
  height: 40px;
  margin-right: 8px;
`;

const RightHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  font-family: "Noto Sans", sans-serif;
  margin-bottom: 20px;
`;

const Left = styled.div`
  flex: 1;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const Right = styled.div`
  width: 380px;
  margin-left: 40px;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const RightBox = styled.div`
  //background: #f4f9fc;
  //background: rgb(244, 244, 244);
  background: rgb(237, 231, 227);
  border-radius: 12px;
  box-sizing: border-box;
  padding: 32px;
  margin-bottom: 32px;
  @media (max-width: 800px) {
    padding: 20px;
  }
`;

const TripletPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  font-family: "Noto Sans", sans-serif;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const TripletHeading = styled.div`
  font-size: 50px;
  line-height: 72px;
  font-weight: bold;
  padding-top: 20px;
  border-top: 2px solid lightgrey;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 1200px) {
    font-size: 42px;
  }
`;

const TripletSub = styled.div`
  font-size: 28px;
  opacity: 0.5;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 800px) {
    font-size: 20px;
  }
`;

const TripletItem = styled.div`
  flex: 1;
  padding: 40px;
  text-align: left;
  padding-left: 10px;

  :first-of-type {

  }

  @media (max-width: 800px) {
    font-size: 20px;
    padding-bottom: 10px;
  }
`;

const NewContent = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  line-height: 32px;
`;

const ContentPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 800px) {
    display: block;
  }
`;

const BackLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.grey};
  cursor: pointer;
`;

const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
  @media (max-width: 800px) {
    font-size: 20px;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default ContactsPage;
